<template>
  <div>
    <!-- ヨクスル用 -->
    <div class="audit-data is-noborder" v-if="!isProxy">
      <div class="audit-data__info">
        <div class="name">
          <span class="name-label">監査名：</span>
          <span class="audit-data-name js-audit-data-name">{{ this.diagTitle }}</span>
          <a @click="changeDiagTitle(true)" class="link-arrow" style="margin-left: 2rem;">変更</a>
        </div>
        <div class="corse">{{ this.diagCourseName }}</div>
        <div class="label-update"><span v-show="diagRevisionFlg">UPDATE</span></div>
      </div>
      <div class="audit-data__btn">
        <div class="btn" v-if="(isIpo && showDownload) || (!isIpo)">
          <a @click="exportResult()" class="link-excel"><img src="@/assets/img/common/icon-excel.svg" alt="">レポートダウンロード</a>
        </div>
        <div class="btn-toggle-group" v-if="isIpo && isAdmin">
          一般ユーザのダウンロードを許可
          <label class="btn-toggle">
            <input class="btn-toggle__checkbox" type="checkbox" role="switch" v-model="canDownloadExcel" @change="changeCanDownloadExcel()">
            <div class="btn-toggle__item"></div>
          </label>
        </div>
      </div>
    </div>

    <!-- 代理店用 -->
    <div class="audit-data" v-if="isProxy">
      <div class="audit-data__info">
        <div class="name">
          <span class="name-label">監査名：</span>
          <span class="audit-data-name js-audit-data-name">{{ this.diagTitle }}</span>
          <a @click="changeDiagTitle(true)" class="link-arrow" style="margin-left: 2rem;">変更</a>
        </div>
        <div class="corse">{{ this.diagCourseName }}</div>
        <div class="progress">
          <p><strong>{{ progress }}％</strong> {{ score }}/{{ totalScore }}</p>
          <div class="progress_bar"><span :style="'width: ' + progress + '%'"></span></div>
        </div>
      </div>
      <div class="btn">
        <a @click="exportResult()" class="link-excel"><img src="@/assets/img/common/icon-excel.svg" alt="">レポートダウンロード</a>
      </div>
    </div>
  </div>
</template>


<script>
import { saveAs } from "file-saver";

export default {
  components: {
  },
  data() {
    return {
      execChangeDiagTitle: false
    }
  },
  props: {
    score: {},
    totalScore: {},
    showDownload: {},
    isProxy: {},
    isAdmin: {},
    canDownloadExcel: {},
    isIpo: {},
  },
  computed: {
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    diagTitle() {
      return this.$store.getters['diag/getTitle'];
    },
    diagCourseName() {
      return this.$store.getters['diag/getDiagCourseName'];
    },
    progress() {
      return Math.floor((this.score / this.totalScore) * 100);
    },
    diagRevisionFlg() {
      return this.$store.getters['diag/getDiagRevisionFlg'];
    }
  },
  methods: {
    changeDiagTitle(value) {
      this.execChangeDiagTitle = value;
      this.$emit("emit-diag-title-change", this.execChangeDiagTitle);
    },
    async changeCanDownloadExcel() {
      let res = await this.$axios.post('/ld/api/diag/storeCanDownloadExcel', {
        diagResultId: this.diagResultId,
        canDownloadExcel: this.canDownloadExcel,
      });
      if (res.status==200) {
        this.$toast.info('ダウンロード許可設定を変更しました。');
      }else{
        this.$toast.error(res.data.message);
      }
    },
    async exportResult() {
      this.$toast.info('ダウンロードを開始しました。');
//      await this.$axios.get('/ld/api/diag/export?id=' + this.diagResultId);
      await saveAs('/ld/api/diag/export?id=' + this.diagResultId);
    },
    goNewDiag() {
      this.$router.push({ name: 'diag-course-select' });
    },
  }
}

</script>

